<div class="skeleton">
  <div class="line-container">
    <div class="animated-background"></div>
    <div class="line"></div>
  </div>

  <div class="line-container">
    <div class="animated-background"></div>
    <div class="line"style="width: 80%"></div>
  </div>

  <div class="line-container">
    <div class="animated-background"></div>
    <div class="line"></div>
  </div>
</div>
